import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { PostData } from "../../services/PostData";
import { GetData } from "../../services/GetData";
import {
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Label,
  Input,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Pagination from "react-js-pagination";
import $ from "jquery";
import Loader from "../../Loader";
import StudentPage from "../../views/StudentPage";
const GLOBAL = require("../../Globals");
const txtupper = {
  textTransform: "uppercase",
  fontSize: "20px",
};
const tBorder = { border: "1px solid black", borderCollapse: "collapse" };

class StudentList extends Component {
  /** set property value **/
  constructor(props) {
    super(props);
    this.state = {
      accyear: [],
      acyear: "",
      posts: [],
      postFilter: [],
      modal: false,
      _redirect: false,
      _redirectView: false,
      loading: false,
      currentPage: 1,
      todosPerPage: 20,
      activePage: 1,
      stdname: "",
      stdregno: "",
      filteralert: 1,
      stdmobno: "",
      clas: [],
      cls: "",
      view: "0",
      section: "",
      sections: [],
      viewtype: "grid",
    };
    this.basestate = this.state;
    this.handleClick = this.handleClick.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.onBack = this.onBack.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onClassChange = this.onClassChange.bind(this);
    this.onSecChange = this.onSecChange.bind(this);
    this.onRegnoSearchChange = this.onRegnoSearchChange.bind(this);
    this.onMobChange = this.onMobChange.bind(this);
    this.onShowChange = this.onShowChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onView = this.onView.bind(this);
    this.onManage = this.onManage.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onupdateSubmit = this.onupdateSubmit.bind(this);
    this.onValChange = this.onValChange.bind(this);
    this.onViewTypeChange = this.onViewTypeChange.bind(this);
    this.printDocument = this.printDocument.bind(this);
  }

  onViewTypeChange(e) {
    this.setState({ viewtype: e.target.value });
  }

  onValChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  onManage(dt) {
    this.state.idd = dt;
    this.setState({
      modal: !this.state.modal,
    });
    this.getstuddata();
  }

  onupdateSubmit(e) {
    e.preventDefault();
    this.setState({ isload: true });
    if (this.state.idd) {
      PostData("student/updatestatus", this.state).then((result) => {
        let responseJson = result;
        if (responseJson.status == "1") {
          this.setState({
            _message: "Status Changed Successfully!..",
            alertClass: "alert alert-success",
            modal: !this.state.modal,
            isload: false,
            idd: "",
            estatus: "",
          });
          this.getdata();
        } else {
          this.setState({
            _message: "Unable to Change",
            alertClass: "alert alert-danger",
          });
          this.getdata();
        }
      });
    }
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
    this.getclass();
    this.getdata();
    this.setState({ view: "1" });
  }

  onShowChange(e) {
    if (this.state.filteralert == 1) {
      this.state.todosPerPage = e.target.value;
      this.getdata();
      this.setState({ view: "1" });
    } else {
      this.state.todosPerPage = e.target.value;
      this.filterdata();
      this.setState({ view: "1" });
    }
  }

  onClassChange(e) {
    this.state.cls = e.target.value;
    if (e.target.value != "") {
      this.getsection();
    }
    this.filterdata();
    this.setState({ view: "1" });
  }

  printDocument() {
    //$("#print-report").show();
    var content = document.getElementById("print-report");
    var pri = document.getElementById("print_frame").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }

  onSecChange(e) {
    this.state.section = e.target.value;
    this.filterdata();
    this.setState({ view: "1" });
  }

  onSearchChange(e) {
    this.state.stdname = e.target.value;
    this.filterdata();
    this.setState({ view: "1" });
  }

  onRegnoSearchChange(e) {
    this.state.stdregno = e.target.value;
    this.filterdata();
    this.setState({ view: "1" });
  }

  onMobChange(e) {
    this.state.stdmobno = e.target.value;
    this.filterdata();
    this.setState({ view: "1" });
  }

  handlePageChange(pageNumber) {
    this.setState({ activePage: pageNumber });
    this.state.currentPage = Number(pageNumber);
  }

  onBack(e) {
    this.setState({ _redirect: true });
  }

  handleClick(dd) {
    this.state.id = dd;
    if (window.confirm("Do you want to Delete?")) {
      $("#showLoader").show();
      PostData("student/deletestud", this.state).then((result) => {
        $("#showLoader").show();
        let responseJson = result;
        if (responseJson.status == "1") {
          this.setState({
            _message: "Student Removed Successfullly",
            alertClass: "alert alert-success",
          });
          this.getdata();
        } else {
          this.setState({
            _message: "Error in Remove Student",
            alertClass: "alert alert-danger",
          });
        }
      });
    }
  }

  /** this function will be call when page loading **/
  componentDidMount() {
    this.getacyear();
  }

  /** get Academic Year **/
  getacyear() {
    $("#showLoader").show();
    GetData("academic/getacyear").then((result) => {
      $("#showLoader").hide();
      let responseJson = result;
      if (responseJson) {
        this.setState({
          accyear: responseJson,
        });
        var index = responseJson.findIndex(function (obj) {
          return obj.iscurrent == 1;
        });
        var academic = $("#year").find("option:eq(1)").val();
        this.setState({
          acyear: responseJson[index].id,
        });
        $("#year option")
          .eq(index + 1)
          .prop("selected", true)
          .trigger("change");
        this.getdata();
        this.getclass();
      }
    });
  }

  getdata() {
    this.setState({ loading: true });
    this.setState({ posts: [] });
    var ac = $("#year").val();
    $("#showLoader").show();
    GetData("student/getstdbyac/" + ac).then((result) => {
      $("#showLoader").hide();
      let responseJson = result;
      if (responseJson) {
        this.setState({
          posts: responseJson,
          postFilter: responseJson,
          loading: false,
        });
      }
    });
  }

  getsection() {
    var ac = $("#year").val();
    $("#showLoader").show();
    GetData("section/getsecbyclass/" + ac + "/" + this.state.cls).then(
      (result) => {
        $("#showLoader").hide();
        let responseJson = result;
        if (responseJson) {
          this.setState({
            sections: responseJson,
          });
        }
      }
    );
  }

  getstuddata() {
    var ac = $("#year").val();
    $("#showLoader").show();
    GetData("student/getstudbyid/" + ac + "/" + this.state.idd).then(
      (result) => {
        $("#showLoader").hide();
        let responseJson = result;
        if (responseJson) {
          this.setState({
            studname: responseJson[0]["stdname"],
            estatus: responseJson[0]["activestatus"],
          });
        }
      }
    );
  }

  onUpdate(ac, dt) {
    this.state.ac = ac;
    this.state.idd = dt;
    this.setState({ _redirect: true });
  }

  onView(ac, dt) {
    this.state.ac = ac;
    this.state.idd = dt;
    this.setState({ _redirectView: true });
  }

  /** get Class **/
  getclass() {
    var ac = $("#year").val();
    GetData("classs/getclasbyacyear/" + ac).then((result) => {
      let responseJson = result;
      if (responseJson) {
        this.setState({
          clas: responseJson,
        });
      }
    });
  }

  filterdata() {
    this.setState({ filteralert: 2 });
    this.state.postFilter = [];
    var dat = [];
    for (var i = 0; i < this.state.posts.length; i++) {
      if (
        this.state.stdname != "" &&
        this.state.cls != "" &&
        this.state.section != ""
      ) {
        if (
          this.state.posts[i].stdname
            .toLowerCase()
            .search(this.state.stdname.toLowerCase()) != -1 &&
          this.state.posts[i].class == this.state.cls &&
          this.state.posts[i].section == this.state.section
        ) {
          dat.push(this.state.posts[i]);
        }
      } else if (
        this.state.stdname != "" &&
        this.state.cls == "" &&
        this.state.section == ""
      ) {
        if (
          this.state.posts[i].stdname
            .toLowerCase()
            .search(this.state.stdname.toLowerCase()) != -1
        ) {
          dat.push(this.state.posts[i]);
        }
      } else if (
        this.state.stdname == "" &&
        this.state.cls != "" &&
        this.state.section == ""
      ) {
        if (this.state.posts[i].class == this.state.cls) {
          dat.push(this.state.posts[i]);
        }
      } else if (
        this.state.cls != "" &&
        this.state.section != "" &&
        this.state.stdname == ""
      ) {
        if (
          this.state.posts[i].class == this.state.cls &&
          this.state.posts[i].section == this.state.section
        ) {
          dat.push(this.state.posts[i]);
        }
      } else if (
        this.state.stdname != "" &&
        this.state.cls != "" &&
        this.state.section == ""
      ) {
        if (
          this.state.posts[i].stdname
            .toLowerCase()
            .search(this.state.stdname.toLowerCase()) != -1 &&
          this.state.posts[i].class == this.state.cls
        ) {
          dat.push(this.state.posts[i]);
        }
      } else if (this.state.stdregno != "") {
        if (this.state.posts[i].regno == this.state.stdregno) {
          dat.push(this.state.posts[i]);
        }
      } else if (this.state.stdmobno != "") {
        if (this.state.posts[i].mobile == this.state.stdmobno) {
          dat.push(this.state.posts[i]);
        }
      } else {
        dat.push(this.state.posts[i]);
      }
    }
    this.setState({ postFilter: dat });
  }

  getimage(gen, url) {
    var photo = "";
    if (url == "") {
      if (gen == "Male") {
        photo = GLOBAL.BASE_URL + "/public/avatar/boy.png";
      } else if (gen == "Female") {
        photo = GLOBAL.BASE_URL + "/public/avatar/girl.png";
      }
    } else {
      photo = url;
    }

    return photo;
  }

  render() {
    if (this.state.postFilter.length == 0) {
      $("#nodata").show();
    } else {
      $("#nodata").hide();
    }

    $("#print-report").hide();
    var items = this.state.clas;
    var acyear = this.state.accyear;

    if (this.state.view == "1") {
      $("#showdata").show();
    } else {
      $("#showdata").hide();
    }

    if (this.state._redirect) {
      return (
        <Redirect
          to={"/student/edit/" + this.state.ac + "/" + this.state.idd}
        />
      );
    }

    if (this.state._redirectView) {
      return (
        <Redirect
          to={"/student/view/" + this.state.ac + "/" + this.state.idd}
        />
      );
    }

    this.statuslist = [
      { value: "", name: "-Select-" },
      { value: "active", name: "Active" },
      { value: "left", name: "Left" },
    ];
    /** set showcount select box **/
    this.shows = [
      { value: "10", name: "10" },
      { value: "20", name: "20" },
      { value: "50", name: "50" },
      { value: "100", name: "100" },
    ];

    /** set view type select box **/
    this.vtype = [
      { value: "grid", name: "Grid View" },
      { value: "list", name: "List View" },
    ];

    // Logic for displaying current todos
    const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
    const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
    const currentTodos = this.state.postFilter.slice(
      indexOfFirstTodo,
      indexOfLastTodo
    );

    const renderTodos = currentTodos.map((item, i) => {
      return (
        <tr key={item}>
          <td width="50" className="tablewidth">
            {i + 1}
          </td>
          <td width="250">{item.regno}</td>
          <td width="250">{item.admissionno}</td>
          <td width="500">{item.stdname}</td>
          <td width="150">{item.cls}</td>
          <td width="100">{item.sec}</td>
          <td width="200">{item.mobile}</td>
          <td width="220">
            {/*<button name="manage" className="btn btn-success btn-sm" onClick={() => this.onManage(item.regno)} ><i className="fa fa-check-circle"></i></button>&nbsp;&nbsp;*/}
            <button
              name="view"
              className="btn btn-warning btn-sm"
              onClick={() => this.onView(item.acyear, item.regno)}
            >
              <i className="fa fa-eye"></i>
            </button>
            &nbsp;&nbsp;
            <button
              name="edit"
              className="btn btn-info btn-sm"
              onClick={() => this.onUpdate(item.acyear, item.regno)}
            >
              <i className="fa fa-edit"></i>
            </button>
            &nbsp;&nbsp;
            <button
              name="removesub"
              className="btn btn-danger btn-sm"
              onClick={() => this.handleClick(item.regno)}
            >
              <i className="fa fa-remove"></i>
            </button>
          </td>
        </tr>
      );
    });

    return (
      <div>
        <StudentPage />
        <div className="animated fadeIn">
          <div className={this.state.alertClass}>{this.state._message}</div>
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <strong>Student List</strong>&nbsp;&nbsp; Academic Year :
                  &nbsp;&nbsp;
                  <select
                    name="acyear"
                    onChange={this.onChange}
                    required
                    id="year"
                  >
                    <option value="">Select</option>
                    {acyear.map(function (item) {
                      return <option value={item.id}>{item.value}</option>;
                    })}
                  </select>
                  &nbsp;&nbsp; Reg No : &nbsp;&nbsp;
                  <input
                    type="text"
                    name="stdregno"
                    onChange={this.onRegnoSearchChange}
                  />
                  &nbsp;&nbsp;&nbsp; Name : &nbsp;&nbsp;
                  <input
                    type="text"
                    name="stdname"
                    onChange={this.onSearchChange}
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Mobile : &nbsp;&nbsp;
                  <input
                    type="text"
                    name="stdmobno"
                    onChange={this.onMobChange}
                  />
                  <br />
                  <br />
                  Class : &nbsp;&nbsp;
                  <select name="cls" onChange={this.onClassChange} id="clas">
                    <option value="">Select Class</option>
                    {items.map(function (item) {
                      return <option value={item.class}>{item.cls}</option>;
                    })}
                  </select>
                  &nbsp;&nbsp; Section : &nbsp;&nbsp;
                  <select name="section" onChange={this.onSecChange} id="secs">
                    <option value="">Select Section</option>
                    {this.state.sections.map(function (item) {
                      return <option value={item.section}>{item.secs}</option>;
                    })}
                  </select>
                  &nbsp;&nbsp; Total Students :{" "}
                  <span>{this.state.postFilter.length}</span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; show &nbsp;
                  <select name="show" onChange={this.onShowChange} id="show">
                    {this.shows.map((e, key) => {
                      return (
                        <option key={key} value={e.value}>
                          {e.name}
                        </option>
                      );
                    })}
                  </select>
                  &nbsp; entries&nbsp; View Type &nbsp;
                  <select name="vtype" onChange={this.onViewTypeChange}>
                    {this.vtype.map((e, key) => {
                      return (
                        <option key={key} value={e.value}>
                          {e.name}
                        </option>
                      );
                    })}
                  </select>
                  &nbsp;
                  <Button
                    size="sm"
                    className="btn-right"
                    color="warning"
                    onClick={this.printDocument}
                  >
                    <i className="fa fa-print"></i> Print
                  </Button>
                </CardHeader>
                {this.state.viewtype == "list" ? (
                  <CardBody>
                    <Table responsive striped id="showdata">
                      <thead>
                        <tr>
                          <th width="50" className="tablewidth">
                            S.No
                          </th>
                          <th width="250">Reg No</th>
                          <th width="250">Admission No</th>
                          <th width="500">Student Name</th>
                          <th width="150">Class</th>
                          <th width="100">Section</th>
                          <th width="200">Mobile</th>
                          <th width="300">Manage</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading ? (
                          <tr>
                            <td colSpan="8">
                              <center>
                                <Loader />
                              </center>
                            </td>
                          </tr>
                        ) : (
                          renderTodos
                        )}
                        <br></br>
                        <Pagination
                          activePage={this.state.activePage}
                          itemsCountPerPage={this.state.todosPerPage}
                          pageRangeDisplayed={3}
                          totalItemsCount={this.state.postFilter.length}
                          onChange={this.handlePageChange}
                        />
                      </tbody>
                    </Table>
                  </CardBody>
                ) : (
                  <CardBody>
                    <Row id="showdata">
                      {this.state.postFilter.map((item, i) => (
                        <Col md="4" className="studentgrid">
                          <Card
                            className="overlay-card"
                            style={{ minHeight: "147px" }}
                          >
                            <CardBody>
                              <Row>
                                <Col md="3">
                                  <img
                                    src={this.getimage(item.gender, item.photo)}
                                    width="75px"
                                    style={{ border: "2px solid grey" }}
                                  />
                                </Col>
                                <Col md="9" style={{ paddingLeft: "30px" }}>
                                  {item.regno}
                                  <br />
                                  {item.stdname}
                                  <br />
                                  {item.cls} - {item.sec}
                                  <br />
                                  {item.mobile}
                                  <br />
                                  {item.city}
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                          <div className="overlay-div">
                            <div className="fourbuttons">
                              {/*<button name="view" className="btn btn-warning btn-md view-btn" onClick={() => this.onView(item.acyear,item.regno)} ><i className="fa fa-eye" style={{fontSize:'18px'}}></i></button>
								&nbsp;&nbsp;
								<button name="edit" className="btn btn-info btn-md edit-btn" onClick={() => this.onUpdate(item.acyear,item.regno)} ><i className="fa fa-edit" style={{fontSize:'18px'}}></i></button>
								&nbsp;&nbsp;
								<button name="removesub" className="btn btn-danger btn-md remove-btn" onClick={() => this.handleClick(item.regno)} ><i className="fa fa-remove" style={{fontSize:'18px'}}></i></button>
								&nbsp;&nbsp;
							  <button name="transferstudent" className="btn btn-warning btn-md transfer-btn" onClick={() => this.handleTransfer(item.regno)} ><i className="fa fa-sign-out" style={{fontSize:'18px'}}></i></button>*/}
                              {/*<button name="manage" className="btn btn-success btn-md view-btn" onClick={() => this.onManage(item.regno)} ><i className="fa fa-check-circle"></i></button>&nbsp;&nbsp;*/}
                              <button
                                name="view"
                                className="btn btn-warning btn-md edit-btn"
                                onClick={() =>
                                  this.onView(item.acyear, item.regno)
                                }
                              >
                                <i className="fa fa-eye"></i>
                              </button>
                              &nbsp;&nbsp;
                              <button
                                name="edit"
                                className="btn btn-info btn-md remove-btn"
                                onClick={() =>
                                  this.onUpdate(item.acyear, item.regno)
                                }
                              >
                                <i className="fa fa-edit"></i>
                              </button>
                              &nbsp;&nbsp;
                              <button
                                name="removesub"
                                className="btn btn-danger btn-md transfer-btn"
                                onClick={() => this.handleClick(item.regno)}
                              >
                                <i className="fa fa-remove"></i>
                              </button>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </CardBody>
                )}
              </Card>
              <Card>
                <CardBody id="print-report">
                  <Row>
                    <table id="hide_div" width="100%">
                      <tbody>
                        <tr>
                          <td align="center">
                            <img
                              src={GLOBAL.BASE_URL + "public/sclogo/logo.jpg"}
                              width="60"
                              style={{
                                position: "absolute",
                                top: "10px",
                                left: "100px",
                              }}
                            />
                            <b style={txtupper}>{GLOBAL.Sclful_NAME}</b>
                            <br />
                            <b
                              style={{
                                textTransform: "uppercase",
                                fontSize: "15px",
                              }}
                            >
                              {GLOBAL.Scl_Addr}
                            </b>
                            <br />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    <Col md="12">
                      <table style={tBorder} width="100%">
                        <thead>
                          <tr>
                            <th style={tBorder}>S.No</th>
                            <th style={tBorder}>Regno</th>
                            <th style={tBorder}>Student Name</th>
                            <th style={tBorder}>Class</th>
                            <th style={tBorder}>Section</th>
                            <th style={tBorder}>Mobile</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.postFilter.map((item, index) => (
                            <tr key={item}>
                              <td style={tBorder}>{index + 1}</td>
                              <td style={tBorder}>{item.regno}</td>
                              <td style={tBorder}>{item.stdname}</td>
                              <td style={tBorder}>{item.cls}</td>
                              <td style={tBorder}>{item.sec}</td>
                              <td style={tBorder}>{item.mobile}</td>
                            </tr>
                          ))}
                        </tbody>
                        <tbody id="nodata">
                          <tr>
                            <td style={tBorder} colSpan="7" align="center">
                              <span id="datanotfound">Data not found...</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                </CardBody>
                <iframe
                  name="print_frame"
                  id="print_frame"
                  width="0"
                  height="0"
                  frameborder="0"
                  src="about:blank"
                ></iframe>
              </Card>
            </Col>
            <Modal
              isOpen={this.state.modal}
              toggle={this.toggle}
              className={"modal-lg " + this.props.className}
            >
              <form
                action=""
                method="post"
                role="form"
                id="chform"
                encType="multipart/form-data"
                onSubmit={this.onupdateSubmit}
              >
                <input type="hidden" name="acyear" value={this.state.acyear} />
                <input type="hidden" name="idd" value={this.state.idd} />
                <ModalHeader toggle={this.toggle}>
                  Student Name : {this.state.studname} &nbsp;Regno :{" "}
                  {this.state.idd}
                </ModalHeader>
                <ModalBody>
                  <Row>
                    <Col md="3">
                      <FormGroup>
                        <Label>Status</Label>
                      </FormGroup>
                    </Col>
                    <Col md="9">
                      <FormGroup>
                        <select
                          name="estatus"
                          className="form-control"
                          value={this.state.estatus}
                          onChange={this.onValChange}
                          required
                          id="estatus"
                        >
                          {this.statuslist.map((e, key) => {
                            return (
                              <option key={key} value={e.value}>
                                {e.name}
                              </option>
                            );
                          })}
                        </select>
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label>Date</Label>
                      </FormGroup>
                    </Col>
                    <Col md="9">
                      <FormGroup>
                        <Input
                          type="date"
                          name="estdate"
                          className="form-control"
                          onChange={this.onValChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </ModalBody>
                <ModalFooter>
                  <Button type="submit" color="success">
                    {this.state.isload ? <Loader /> : "Update"}
                  </Button>{" "}
                  <Button color="secondary" onClick={this.toggle}>
                    Cancel
                  </Button>
                </ModalFooter>
              </form>
            </Modal>
          </Row>
        </div>
      </div>
    );
  }
}

export default StudentList;



// WEBPACK FOOTER //
// ./src/student/Admission/StudentList.js